import * as React from "react";
import MaterialDateTimePickerComponent from "../MaterialDateTimePickerComponent";
import { makeStyles, createStyles, Theme } from "@material-ui/core";
import uuidv4 from "../../helpers/uuid";
import { IEnumerable, NullableDate } from "../../core/models/ModelHelpers";
import max from "lodash/max";
import addTime from "../../helpers/datetime";
import { DATEPICKER_MAX_DATE_MESSAGE } from "../../core/constants/datePickerConstants";
import { isAfter } from "date-fns";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "display": "flex",
      "alignItems": "center",
      "color": theme.customPalette.text.darkgrey,

      "& > span:first-child": {
        marginRight: 10,
      },

      "& .pickers-wrapper": {
        "& > *:first-child": {
          marginRight: theme.spacing(1),
        },
      },
    },
  })
);

type MaterialDatePickerPairComponentProps = {
  id?: IEnumerable;
  start?: NullableDate;
  end?: NullableDate;
  onChangeStart?: (date: NullableDate) => void;
  onChangeEnd?: (date: NullableDate) => void;
};

function MaterialDatePickerPairComponent(props: MaterialDatePickerPairComponentProps) {
  const { id, start, end, onChangeStart, onChangeEnd } = props;

  const classes = useStyles();

  const useId = React.useMemo(() => id || uuidv4(), [id]);

  function handleChangeStart(date: NullableDate) {
    // eslint-disable-next-line no-console
    onChangeStart ? onChangeStart(date) : console.log(date);
  }

  function handleChangeEnd(date: NullableDate) {
    // eslint-disable-next-line no-console
    onChangeEnd ? onChangeEnd(date) : console.log(date);
  }

  const minDatePossible = addTime(new Date(), -6, "mo");
  const useStart = start || new Date();
  const useEnd = end || new Date();

  return (
    <div className={classes.root}>
      <span>
        <strong>Data:</strong>
      </span>
      <div className="pickers-wrapper">
        <MaterialDateTimePickerComponent
          key={`MaterialDateTimePickerComponent_start_${useId}`}
          label="Início"
          value={useStart}
          onChange={handleChangeStart}
          minDate={minDatePossible}
          minDateMessage="Dados só são armazenados por 6 meses, logo a data não pode ser anterior a esse período"
          maxDate={end}
          disableFuture
          maxDateMessage={
            isAfter(useStart, useEnd)
              ? DATEPICKER_MAX_DATE_MESSAGE
              : "Não é possível selecionar uma data futura!"
          }
        />

        <MaterialDateTimePickerComponent
          key={`MaterialDateTimePickerComponent_end_${useId}`}
          label="Fim"
          value={useEnd}
          onChange={handleChangeEnd}
          minDate={max([start, minDatePossible])}
          minDateMessage={
            isAfter(useEnd, useStart)
              ? "Dados só são armazenados por 6 meses, logo a data não pode ser anterior a esse período"
              : DATEPICKER_MAX_DATE_MESSAGE
          }
          maxDateMessage={"Não é possível selecionar uma data futura!"}
        />
      </div>
    </div>
  );
}

export default MaterialDatePickerPairComponent;
